import React from "react";

// Import all brand images
import bosch from "../assets/BrandImages/bosch.png";
import benq from "../assets/BrandImages/benq.png";
import blackanddecker from "../assets/BrandImages/blackanddecker.png";
import bose from "../assets/BrandImages/bose.png";
import dewalt from "../assets/BrandImages/dewalt.png";
import ebco from "../assets/BrandImages/ebco.png";
import fevicol from "../assets/BrandImages/fevicol.png";
import godrej from "../assets/BrandImages/godrej.png";
import haffele from "../assets/BrandImages/haffele.png";
import hettich from "../assets/BrandImages/hettich.png";
import jbl from "../assets/BrandImages/jbl.png";
import lgcinebeam from "../assets/BrandImages/lgcinebeam.png";
import makita from "../assets/BrandImages/makita.png";
import samsung from "../assets/BrandImages/samsung.png";
import sg from "../assets/BrandImages/sg.png";
import sony from "../assets/BrandImages/sony.png";
import stanley from "../assets/BrandImages/stanley.png";
import wipro from "../assets/BrandImages/wipro.png";

const RollingBrands = () => {
  const brands = [
    blackanddecker,
    bose,
    dewalt,
    ebco,
    fevicol,
    godrej,
    haffele,
    hettich,
    jbl,
    lgcinebeam,
    makita,
    samsung,
    sg,
    sony,
    stanley,
    wipro,
    benq,
    bosch,
  ];

  return (
    <div className="bg-gray-100 py-8 rounded-xl">
      <div className="overflow-hidden relative">
        {/* Wrapper for the scrolling content */}
        <div className="flex animate-scroll space-x-8">
          {/* Loop the brands array */}
          {[...brands, ...brands].map((brand, index) => (
            <img
              key={index}
              src={brand}
              alt={`Brand ${index + 1}`}
              className="h-24 w-auto m-10 object-contain"
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default RollingBrands;
